/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-10 13:43:30
 * @FilePath: \senlan-ai-ui\src\api\image.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from './index.ts'
interface ImageParams {
  style?: string // 图片格式
  resolution?: string // 图像宽高，范围在 512 ～ 1440，默认是 1080 * 1080
  conversationId: string
  genNum: number
  size: string
}

interface Image2TextParams {
  prompt?: string
}

// 生成图片接口
export const getImage = async (
  prompt: string,
  params?: ImageParams
): Promise<Response> => {
  return http.post('/image/generate', {
    ...params,
    prompt,
  })
}

// 解析图片接口
export const postImage = async (
  image: File,
  callback: (value: Uint8Array) => void,
  params?: Image2TextParams
): Promise<Response> => {
  const { prompt } = params || {}

  const formData = new FormData()
  formData.append('prompt', prompt || '')
  formData.append('image', image)
  return http.post('/image2text', formData)
}
